import(/* webpackMode: "eager" */ "C:\\Users\\Andres\\Desktop\\GenWebsite\\frontend\\src\\app\\maintenance\\page.js");
